<script lang="ts">
    import type {Link} from 'typings/portaro.be.types';
    import type {ComponentSize} from '../../ui-widgets/types';
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import KpLinkButton from '../kp-link/KpLinkButton.svelte';
    import KpDropdownButton from '../../ui-widgets/dropdown/KpDropdownButton.svelte';
    import KpLink from '../kp-link/KpLink.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let links: Link[];
    export let dropdownButtonText: string | null = null;
    export let singleButtonOverwriteLinkText: string | null = null;
    export let singleButtonPrefixText: string | null = null;
    export let showIfEmpty = true;
    export let buttonSize: ComponentSize = 'md';
    export let forceDropdown = false;
    export let isBlock = false;
    export let additionalClasses = '';
    export let forceNewWindow = false;
    export let icon: UIcons | null = null;

    function adjustLinkText(link: Link): Link {
        if (singleButtonOverwriteLinkText) {
            link.text = singleButtonOverwriteLinkText;
        }

        if (singleButtonPrefixText) {
            link.text = singleButtonPrefixText + link.text;
        }

        return link;
    }
</script>

{#if showIfEmpty || links.length > 0}
    {#if links.length === 1 && !forceDropdown}
        <KpLinkButton link={adjustLinkText(links[0])} {isBlock} {buttonSize} {additionalClasses} {forceNewWindow} {icon}/>
    {/if}

    {#if links.length > 1 || forceDropdown}
        <KpDropdownButton {isBlock} {buttonSize} additionalContainerClasses={additionalClasses}>
            <svelte:fragment slot="button">
                <IconedContent {icon} trailingIcon="angle-small-down">
                    {dropdownButtonText}
                </IconedContent>
            </svelte:fragment>

            <svelte:fragment slot="menu">
                {#each links as link}
                    <li>
                        {#if link.note}
                            <KpLink {link} {forceNewWindow}><small class="text-muted">{link.note}</small></KpLink>
                        {:else}
                            <KpLink {link} {forceNewWindow}/>
                        {/if}
                    </li>
                {/each}
            </svelte:fragment>
        </KpDropdownButton>
    {/if}
{/if}